<template>
  <div>
    <page-header title="Alunos Quero Pago">
      <template #description>
        Lista de alunos com cobrança ativa no Quero Pago. Busque por
        nome, CPF, e-mail ou telefone e abra o cadastro pra ver
        mensalidades, contratos, pagamentos e histórico financeiro.
      </template>
    </page-header>

    <div class="row">
      <div class="col-md-9">
        <div class="input-group input-group-lg search-student-field">
          <input v-model="search" type="text" class="form-control"
                 ref="searchInput" placeholder="Pesquisar aluno por nome, cpf, email ou telefone"
                 @keyup.enter="searchStudents"
          >
          <span class="input-group-btn">
            <button class="btn btn-primary" type="button" @click="searchStudents">Pesquisar</button>
          </span>
        </div>
      </div>
    </div>

    <div class="row students-list">
      <div class="col-md-12">
        <div class="list-group">
          <router-link class="list-group-item" :to="{ name: 'student-details', params: { id: student.id } }"
                       v-for="student in students" :key="student.id"
          >
            <div class="row">
              <div class="col-md-5">
                <div>
                  <div class="students-list__name">
                    <strong>{{ student.name }}</strong>
                  </div>
                  {{ student.cpf }}
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <span class="students-list__email-header">Email</span>
                  <div class="students-list__email">
                    {{ student.email }}
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <span class="students-list__cellphone-header">Telefone</span>
                  <div class="students-list__cellphone">
                    {{ student.formatted_cellphone | formatCellphone }}
                  </div>
                </div>
              </div>
            </div>
          </router-link>

          <br>

          <div v-if="totalPages">
            <pagination ref="pagination" :total-pages="totalPages" @page-changed="onPageChange" />
          </div>
        </div>
        <div v-if="students.length === 0">
          Nenhum aluno encontrado.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StudentsService from 'services/StudentsService';
import Pagination from 'components/Pagination';

export default {
  data() {
    return {
      students: [],
      page: 1,
      totalPages: null,
      search: this.$route.query.search || '',
    };
  },
  mounted() {
    this.loadStudents();
    this.$refs.searchInput.focus();
  },
  components: {
    Pagination,
  },
  methods: {
    onPageChange(page) {
      this.page = page;
      this.loadStudents();
    },
    searchStudents() {
      this.page = 1;
      this.totalPages = null;
      this.loadStudents();
    },
    loadStudents() {
      this.$loader.show();
      StudentsService.getStudents(this.search, this.page).then((response) => {
        this.students = response.students;
        this.totalPages = response.total_pages;
        this.$loader.hide();
      })
        .catch((error) => {
          this.$loader.hide();
          this.$alert.notifyAlert(error.response.data.message);
        });
    },
  },
};
</script>
